import { defaultTheme } from '@xstyled/styled-components';
export const appTheme = {
  ...defaultTheme,
  breakpoints: ['600px', '900px', '1200px'],
  space: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '40px',
    xxxl: '70px'
  },
  sizes: {
    xs: '150px',
    sm: '250px',
    md: '350px',
    lg: '450px',
    xl: '550px'
  },
  fonts: {
    title: 'var(--title-font)',
    default: 'var(--body-font)',
    llama: 'var(--llama-font)'
  },
  fontSizes: {
    xxs: '10px',
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '24px',
    xxl: '36px'
  },
  colors: {
    black: 'var(--color-black)',
    white: 'var(--color-white)',

    greyDark: 'var(--color-grey-dk)',
    greyMed: 'var(--color-grey-md)',
    greyLight: 'var(--color-grey-lt)',

    accentDark: 'var(--color-accent-dk)',
    accentMed: 'var(--color-accent-md)',
    accentLight: 'var(--color-accent-lt)',

    yellowDark: 'var(--color-yellow-dk)',
    yellowMed: 'var(--color-yellow-md)',
    yellowLight: 'var(--color-yellow-lt)',

    greenDark: 'var(--color-green-dk)',
    greenMed: 'var(--color-green-md)',
    greenLight: 'var(--color-green-lt)',

    redDark: 'var(--color-red-dk)',
    redMed: 'var(--color-red-md)',
    redLight: 'var(--color-red-lt)',

    blueMed: 'var(--color-blue-md)',

    pinkLight: 'var(--color-pink-lt)',
    pinkLight2: 'var(--color-pink-lt2)',

    overlayDark: 'rgba(0,0,0,0.8)',
    overlayMed: 'rgba(0,0,0,0.6)',
    overlayLight: 'rgba(0,0,0,0.4)',
    overlayClear: 'rgba(0,0,0,0)'
  },
  radii: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    xl: '20px'
  },
  zIndices: {
    hud: 100,
    overlay: 200,
    dialogs: 300,
    toast: 400
  }
};

export type AppTheme = typeof appTheme;
